<script>
import ImageMixin from '@src/mixins/imageMixin.js'

export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  mixins: [
    ImageMixin
  ],
}
</script>

<template>
  <div class="card-container">
    <div class="user-image" :style="getBackground(user.image[0])"></div>
    <p class="user-name">
      {{ user.name }}
    </p>
    <p class="user-post">
      {{ user.position }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.card-container {
  min-width: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
}

.user-name {
  font-family: Open Sans Bold, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 26px;
  color: $dark-blue;
  margin-top: 11px;
}

.user-post {
  margin: 6px 0;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 21px;
  color: $hover-blue;
}

.user-image {
  height: 100px;
  width: 100px;
  border-radius: 50px;
  background-size: cover;
  background-position: center;
}

@media only screen and (max-width: $container-width-xs) {
  .card-container {
    margin-bottom: 35px;
  }

  .user-name {
    font-size: 16px;
    line-height: 21px;
  }

  .user-post {
    font-size: 14px;
    line-height: 23px;
  }
}
</style>
